export const BaseApi = "https://server.minacandles.ir";
export const BaseUrl ="https://server.minacandles.ir/v1";
export const fileUrl = "https://server.minacandles.ir/admin/filemanagers/";
export const PublicFileUrl = "https://server.minacandles.ir/public/files/";

export const buildPublicFileUrl = (file, { vendor = false, variant = "" } = {}) => {
  const name = typeof file === "string" ? file : file?.name;
  if (!name) return (!variant && file?.url) || "";
  const base = vendor ? `${BaseApi}/public/vendors/` : PublicFileUrl;
  return `${base}${encodeURIComponent(`${variant}${name}`)}`;
};

export const publicImageProps = (file, options = {}) => ({
  src: buildPublicFileUrl(file, options),
  onError: (event) => {
    const original = buildPublicFileUrl(file, { vendor: options.vendor });
    if (options.variant && event.currentTarget.getAttribute("src") !== original) {
      event.currentTarget.src = original;
    }
  },
});
